/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Submit_Check_Own_ListingInputs */

const en_directory_submit_check_own_listing = /** @type {(inputs: Directory_Submit_Check_Own_ListingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You already submitted ${i?.name}.`)
};

const zh_directory_submit_check_own_listing = /** @type {(inputs: Directory_Submit_Check_Own_ListingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你已提交过 ${i?.name}。`)
};

/**
* | output |
* | --- |
* | "You already submitted {name}." |
*
* @param {Directory_Submit_Check_Own_ListingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_own_listing = /** @type {((inputs: Directory_Submit_Check_Own_ListingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_Own_ListingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_own_listing(inputs)
	return zh_directory_submit_check_own_listing(inputs)
});
export { directory_submit_check_own_listing as "directory.submit.check.own_listing" }